'use client'
export const errorMessages = {
  413: 'Your request was too large to submit successfully.',
}
